import { AxiosResponse } from 'axios';
import { createAxios, createDealerAxios } from 'src/factories/axios-factory';
import { NotificationReceived } from 'src/types/notification/notification';

// const dealerBackend = createDealerAxios(process.env.DealersApiUrl!);
const dealerBackend = createDealerAxios(process.env.DealersApiUrl!);//"https://localhost:44326/v3"

const NotificationService = {
	getAuthenticationToken(aid: string) {
		return new Promise<string>((resolve, reject) => {
			dealerBackend
				.get(`/notification/token?aid=${aid}`)
				.then((response: AxiosResponse) => {
					resolve(response.data.token);
				})
				.catch((error: any) => {
					window.console.error(error.message);
					reject(error);
				});
		});
	},
	getClientAccessUrl(token: string) {
		return new Promise<string>((resolve, reject) => {
			dealerBackend
				.get(`/negotiate?access_token=${token}`)
				.then((response: AxiosResponse) => {
					resolve(response.data.url);
				})
				.catch((error: any) => {
					window.console.error('Failed to negotiate WebSocket connection.');
					reject(error);
				});
		});
	}
};

export default NotificationService;
